var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.43,19.92v-2.7H18.35v2.69H15.5V11.25h2.85v3.47h2.08V10.84a1.68,1.68,0,0,0-1.67-1.68H15.5V3.68A1.68,1.68,0,0,0,13.83,2H10.17A1.68,1.68,0,0,0,8.49,3.68v4H5.24A1.68,1.68,0,0,0,3.56,9.34V19.92H2V22H22V19.92Zm-11.94,0H5.64V9.75H8.49Zm4.93-9.07v9.08H10.57V9.34h0V4.08h2.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.63a573ec63cb470a16483e2319044dc2.svg";
export { ForwardRef as ReactComponent };